import React from 'react';
import { motion } from 'framer-motion';
import type { ContentfulComponentDefinition } from '../ContentfulComponent';

const getVariants = (
  type: string,
  origin: string,
  duration: number,
  delay: number,
) => {
  const offset = 50;
  let x = 0;
  let y = 0;

  if (origin === 'left') {
    x = -offset;
  } else if (origin === 'right') {
    x = offset;
  }

  if (origin === 'top') {
    y = -offset;
  } else if (origin === 'bottom') {
    y = offset;
  }

  const initial = {
    opacity: type.includes('fade') ? 0 : 1,
    x,
    y,
  };

  const animate = {
    opacity: 1,
    x: 0,
    y: 0,
    transition: {
      duration,
      delay,
    },
  };

  return { initial, animate };
};

export type AnimationSettingsDefinition = ContentfulComponentDefinition & {
  animationType: string,
  duration: number,
  delay: number,
  origin: string,
  internal: {
    type: 'ContentfulSubComponentAnimationSettings',
  }
};

export type AnimationSettingsProps = {
  content: AnimationSettingsDefinition,
  children?: React.ReactNode,
  active?: boolean,
};

const AnimationSettings = ({
  content,
  children,
  active = false,
}: AnimationSettingsProps) => {
  const {
    animationType = 'fade-in',
    duration = 0.5,
    delay = 0,
    origin = 'bottom',
  } = content || {};

  const variants = getVariants(animationType, origin, duration, delay);

  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate={active ? 'animate' : 'initial'}
      className="absolute bottom-0 left-0 right-0 z-20"
    >
      {children}
    </motion.div>
  );
};

export default AnimationSettings;
